import script from "./HealthPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./HealthPanel.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
